import { Button } from 'antd';
import Styled from 'styled-components';

const ButtonGroup = Button.Group;

const ButtonStyled = Styled(Button)`
    
`;

const ButtonStyledGroup = Styled(ButtonGroup)`
    
`;

export { ButtonStyled, ButtonStyledGroup };
